import BIForm from './form';

class AddressForm extends BIForm {

    constructor(data) {
        super(data);
        this.refreshStateCountyInput.bind(this);
        let self = this;
        $('[name="country"]', this.form).on('change', function () {
            self.refreshStateCountyInput();
        });
    }

    populateFields(id, callback) {
        let self = this;
        super.populateFields(id, (form, data) => {
            callback(form, data);
            self.refreshStateCountyInput()
        });
    }

    refreshStateCountyInput() {
        if ($('[name="country"]', this.form).val() === 'US') {
            $('.state', this.form).showSelect();
            $('.county', this.form).addClass('hidden').removeAttr('required');
        } else {
            $('.state', this.form).hideSelect();
            $('.county', this.form).removeClass('hidden');
        }
    }
}



export default AddressForm;